import { Link } from '@tanstack/react-router'
import { Hanko } from './Hanko'
import { LocaleSwitch } from './LocaleSwitch'
import { useLocale } from './use-locale'

export function SiteHeader({
  variant = 'overlay',
  showEnter = true,
}: {
  variant?: 'overlay' | 'solid'
  showEnter?: boolean
}) {
  const { t, path } = useLocale()
  return (
    <header className={`site-header site-header--${variant}`}>
      <a className="skip-link" href="#main">
        {t.nav.skipToContent}
      </a>
      <Link to={path('/')} className="brand">
        <Hanko className="brand__seal" />
        <span className="brand__name">Focus Cafe</span>
      </Link>
      <nav className="site-header__nav" aria-label="Focus Cafe">
        <Link to={path('/ranking')} className="nav-ranking" aria-label={t.nav.ranking}>
          <svg className="nav-ranking__icon" viewBox="0 0 20 20" aria-hidden="true">
            <path d="M7.5 17.5v-11h5v11M2.5 17.5v-6h5M12.5 17.5v-8h5v8M1.5 17.5h17" />
          </svg>
          <span className="nav-ranking__label">{t.nav.ranking}</span>
        </Link>
        <LocaleSwitch />
        {showEnter && (
          <Link to={path('/cafe')} className="nav-enter">
            <span className="nav-enter__dot" aria-hidden="true" />
            {t.nav.enter}
          </Link>
        )}
      </nav>
    </header>
  )
}
